import '@babel/polyfill'
import Vue from 'vue'
import VueMultianalytics from 'vue-multianalytics'
import vuetify from './plugins/vuetify'
import './plugins/vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'
import setupInterceptors from './interceptors'
import VueNestable from 'vue-nestable'
import VueHtmlToPaper from 'vue-html-to-paper'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome)
Vue.component('font-awesome-icon', FontAwesomeIcon)

const options = {
  specs: [
    'fullscreen=no',
    'titlebar=yes',
    'scrollbars=no'
  ],
  styles: [
    'https://cdn.jsdelivr.net/gh/nhn/tui.editor/apps/editor/src/css/contents.min.css'
  ]
}

Vue.use(VueHtmlToPaper, options)
Vue.use(VueNestable)

setupInterceptors()

Vue.config.productionTip = true

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueMultianalytics, {
    modules: {
      mixpanel: { token: process.env.VUE_APP_MIXPANEL_TOKEN || null }
    },
    routing: {
      vueRouter: router
    }
  })
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
